/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-19 16:59:14
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-22 12:27:52
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/ProductDraggableDisplay/ImgSkuAndNameLongDisplay/index.tsx
 */
/**
 *  Product Draggable
 *  Author: Luke
 *  CreatedAt: 2021-03-05
 */
import React from 'react';

//import css from './SalesChannelEditorPromotion.less';

import DragNDropColumns, {
  EnumContainerStyle,
  EnumPosition,
} from 'src/components/DragNDropColumns';
import ProductDisplayInRowLong from '@/src/components/DragRowDisplay/ProductDisplayInRowLong';
import ProductSelection from 'src/constrains/ProductSelectionNoPagination/GeneralSalesChannelProductSelection';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const ImgSkuAndNameLongDisplay = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [visible, setVisible] = React.useState(false);
  const {
    droppableId,
    data,
    onChange,
    onSort,
    onDelete,
    addContainerClassName,
    dragContainerClassName,
    salesChannelUuid,
    disabled,
  } = props;
  const childGenerate = (data, index) => {
    const { sku, productName, thumbnailUrl } = data || {};
    return (
      <ProductDisplayInRowLong
        sku={sku}
        name={productName}
        img={thumbnailUrl}
      />
    );
  };
  const onCancel = () => {
    setVisible(false);
  };
  const onAdd = () => {
    setVisible(true);
  };
  const onOk = (products = []) => {
    const _pWithDraggableId = products.map((i) => {
      const { uuid } = i;
      return { ...i, draggableId: uuid };
    });
    onChange(_pWithDraggableId);
  };
  const _onSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    if (onSort) onSort(oldIndex, newIndex);
  };
  const _onDelete = (index) => {
    if (onDelete) onDelete(index);
  };
  return (
    <React.Fragment>
      {visible && (
        <ProductSelection
          visible={visible}
          onCancel={onCancel}
          onOk={onOk}
          selectedItems={data}
          salesChannelUuid={salesChannelUuid}
        />
      )}

      <DragNDropColumns
        hideTitle
        childGenerate={childGenerate}
        onDelete={_onDelete}
        data={data}
        droppableId={droppableId}
        onSort={_onSort}
        onAdd={onAdd}
        addText={`+ ${getI18n('general.addProducts')}`}
        dragContainerStyle={EnumContainerStyle.largeWithoutBkg}
        addTextPosition={EnumPosition.top}
        addContainerClassName={addContainerClassName}
        dragContainerClassName={dragContainerClassName}
        disabled={disabled}
      />
    </React.Fragment>
  );
};
export default ImgSkuAndNameLongDisplay;
